var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "homepage-recommend"
  }, [_c("div", {
    staticClass: "bg-img-upper"
  }), _c("div", {
    staticClass: "bg-img-lower"
  }), _c("div", {
    staticClass: "voice-main"
  }, [_c("h3", {
    staticClass: "module-title"
  }, [_vm._v("客户心声")]), _c("div", {
    staticClass: "swiper-containers"
  }, [_c("div", {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.recommendList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "swiper-slide swiper-lazy"
    }, [_c("section", {
      staticClass: "carousel-box"
    }, [_c("div", {
      staticClass: "box-left"
    }, [_c("img", {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: require(`@/assets/images/homepage/${item.img}`),
        expression: "require(`@/assets/images/homepage/${item.img}`)"
      }],
      attrs: {
        alt: "quanshang"
      }
    })]), _c("section", {
      staticClass: "box-right"
    }, [_c("h4", {
      staticClass: "puhui-M"
    }, [_vm._v(_vm._s(item.leader))]), _c("p", [_vm._v(_vm._s(item.content))]), _c("section", {
      staticClass: "relative-products"
    }, [_c("label", [_vm._v("相关产品：")]), _vm._l(item.relativeProducts, function (ele, i) {
      return _c("router-link", {
        key: i,
        attrs: {
          to: ele.link
        }
      }, [_c("span", {
        staticClass: "product"
      }, [_vm._v(_vm._s(ele.name))])]);
    })], 2)]), _c("img", {
      staticClass: "quotes",
      attrs: {
        alt: "",
        src: require("../../../assets/images/homepage/home-quotes.png")
      }
    })])]);
  }), 0), _vm.recommendList.length > 1 ? _c("div", {
    staticClass: "swiper-pagination area"
  }) : _vm._e(), _vm._m(0)])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pagination-wrap"
  }, [_c("span", {
    staticClass: "home-go-left"
  }), _c("span", {
    staticClass: "home-go-right"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };